/**
 * Normalizes an email address for consistent comparison and storage.
 * @param {string} email
 * @returns {string} Lowercase, trimmed email — or empty string if falsy.
 */
export function normalizeEmail(email) {
  return (email || "").toLowerCase().trim();
}

/**
 * Human "what was paid" label for a `payments` doc — itemized for combined
 * checkouts (new `items` array: deposit + one or more rent months bundled
 * into a single Stripe charge) and single-value for legacy docs (a bare
 * `month`, or a manual record's `type: "deposit"`).
 * @param {object} payment
 * @returns {string}
 */
export function paymentSummaryLabel(payment) {
  if (Array.isArray(payment.items) && payment.items.length) {
    return payment.items.map((it) => (it.type === "deposit" ? "Security Deposit" : it.month)).join(", ");
  }
  if (payment.type === "deposit") return "Security Deposit";
  return payment.month || "—";
}

